import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const tableScrollContentFn = /* @__PURE__ */ createRecipe('table-scroll-content', {}, [])

const tableScrollContentVariantMap = {}

const tableScrollContentVariantKeys = Object.keys(tableScrollContentVariantMap)

export const tableScrollContent = /* @__PURE__ */ Object.assign(memo(tableScrollContentFn.recipeFn), {
  __recipe__: true,
  __name__: 'tableScrollContent',
  __getCompoundVariantCss__: tableScrollContentFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: tableScrollContentVariantKeys,
  variantMap: tableScrollContentVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, tableScrollContentVariantKeys)
  },
  getVariantProps: tableScrollContentFn.getVariantProps,
})